import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { map as __map, filter as __filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../api-configuration";
import * as i2 from "@angular/common/http";
/**
 * Basic Error Controller
 */
class BasicErrorControllerService extends __BaseService {
    constructor(config, http) {
        super(config, http);
    }
    /**
     * @return OK
     */
    errorHtmlUsingGETResponse() {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        let req = new HttpRequest('GET', this.rootUrl + `/error`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @return OK
     */
    errorHtmlUsingGET() {
        return this.errorHtmlUsingGETResponse().pipe(__map(_r => _r.body));
    }
    /**
     * @return OK
     */
    errorHtmlUsingHEADResponse() {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        let req = new HttpRequest('HEAD', this.rootUrl + `/error`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @return OK
     */
    errorHtmlUsingHEAD() {
        return this.errorHtmlUsingHEADResponse().pipe(__map(_r => _r.body));
    }
    /**
     * @return OK
     */
    errorHtmlUsingPOSTResponse() {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        let req = new HttpRequest('POST', this.rootUrl + `/error`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @return OK
     */
    errorHtmlUsingPOST() {
        return this.errorHtmlUsingPOSTResponse().pipe(__map(_r => _r.body));
    }
    /**
     * @return OK
     */
    errorHtmlUsingPUTResponse() {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        let req = new HttpRequest('PUT', this.rootUrl + `/error`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @return OK
     */
    errorHtmlUsingPUT() {
        return this.errorHtmlUsingPUTResponse().pipe(__map(_r => _r.body));
    }
    /**
     * @return OK
     */
    errorHtmlUsingDELETEResponse() {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        let req = new HttpRequest('DELETE', this.rootUrl + `/error`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @return OK
     */
    errorHtmlUsingDELETE() {
        return this.errorHtmlUsingDELETEResponse().pipe(__map(_r => _r.body));
    }
    /**
     * @return OK
     */
    errorHtmlUsingOPTIONSResponse() {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        let req = new HttpRequest('OPTIONS', this.rootUrl + `/error`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @return OK
     */
    errorHtmlUsingOPTIONS() {
        return this.errorHtmlUsingOPTIONSResponse().pipe(__map(_r => _r.body));
    }
    /**
     * @return OK
     */
    errorHtmlUsingPATCHResponse() {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        let req = new HttpRequest('PATCH', this.rootUrl + `/error`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @return OK
     */
    errorHtmlUsingPATCH() {
        return this.errorHtmlUsingPATCHResponse().pipe(__map(_r => _r.body));
    }
}
BasicErrorControllerService.ngInjectableDef = i0.defineInjectable({ factory: function BasicErrorControllerService_Factory() { return new BasicErrorControllerService(i0.inject(i1.ApiConfiguration), i0.inject(i2.HttpClient)); }, token: BasicErrorControllerService, providedIn: "root" });
export { BasicErrorControllerService };
